import request from '@/utils/request'

//部门管理


//部门新增
export function addDept(data) {
  return request({
    method: 'post',
    url: "/organization/api/dept/ga/add",
    data: data
  })
}
//部门编辑
export function editDept(data) {
  return request({
    method: 'post',
    url: "/organization/api/dept/ga/edit",
    data: data
  })
}
//部门删除
export function deleteDept(id) {
  return request({
    method: 'post',
    url: "/organization/api/dept/ga/remove/" + id
  })
}
//部门状态修改
export function changeStatusDept(id, status) {
  return request({
    method: 'post',
    url: "/organization/api/dept/ga/changeStatus/" + status + "/" + id
  })
}
//部门管理树
export function getManageTree() {
  return request({
    method: 'get',
    url: "/organization/api/dept/ga/manageTree"
  })
}
//上传签章
export function upLoadSign(data) {
  return request({
    method: 'post',
    url: "/organization/api/dept/ga/sign",
    data: data
  })
}
//行政区划
export function xzqhTree() {
  return request({
    method: 'get',
    url: "/organization/api/ga/xzqh/tree/no_lazy"
  })
}


/* 统一社会信用代码修改 */
export function updShtyxydm(oldVal, newVal) {
  return request({
    timeout: 3 * 60 * 1000,
    method: 'post',
    url: "/yzdservice/enterprise/yzddw/updShtyxydm/" + oldVal + '/' + newVal
  })
}

/* 重置密码 */
export function resetpwd(data,loginName) {
  return request({
    method: 'put',
    url: "/yzdservice/enterprise/yzddw/resetPwd/"+loginName,
    data: data
  })
}
